// export default RankingDisplay;import React from 'react';
import { Award, MapPin, Home } from 'lucide-react';

// Dummy data - Replace with actual data from your store/API later
const dummyRankingData = {
  state: { rank: 15, total: 250 },
  district: { rank: 3, total: 45 },
  taluk: { rank: 1, total: 12 },
};

const RankingDisplay = ({ rankingData = dummyRankingData }) => {
  // Helper to format rank (e.g., 1st, 2nd, 3rd, 4th)
  const formatRank = (rank) => {
    if (!rank || rank < 1) return 'N/A';
    const j = rank % 10,
          k = rank % 100;
    if (j === 1 && k !== 11) return `${rank}st`;
    if (j === 2 && k !== 12) return `${rank}nd`;
    if (j === 3 && k !== 13) return `${rank}rd`;
    return `${rank}th`;
  };

  return (
    <div className="bg-white rounded-xl p-4 shadow-md w-full max-w-md mx-auto">
      <h2 className="text-gray-600 font-medium text-center mb-4">Your Ranking</h2>
      
      <div className="flex justify-between items-center gap-2">
        {/* State Rank */}
        <div className="bg-yellow-50 rounded-lg p-3 flex flex-col items-center w-28">
          <div className="flex items-center text-yellow-500 mb-1">
            <Award className="w-5 h-5" />
          </div>
          <span className="text-lg font-bold text-gray-800">{formatRank(rankingData.state?.rank)}</span>
          <span className="text-xs text-gray-400">of {rankingData.state?.total}</span>
          <p className="text-xs font-medium text-gray-500">State Rank</p>
        </div>
        
        {/* District Rank */}
        <div className="bg-blue-50 rounded-lg p-3 flex flex-col items-center w-28">
          <div className="flex items-center text-blue-500 mb-1">
            <MapPin className="w-5 h-5" />
          </div>
          <span className="text-lg font-bold text-gray-800">{formatRank(rankingData.district?.rank)}</span>
          <span className="text-xs text-gray-400">of {rankingData.district?.total}</span>
          <p className="text-xs font-medium text-gray-500">District Rank</p>
        </div>
        
        {/* Taluk Rank */}
        <div className="bg-green-50 rounded-lg p-3 flex flex-col items-center w-28">
          <div className="flex items-center text-green-500 mb-1">
            <Home className="w-5 h-5" />
          </div>
          <span className="text-lg font-bold text-gray-800">{formatRank(rankingData.taluk?.rank)}</span>
          <span className="text-xs text-gray-400">of {rankingData.taluk?.total}</span>
          <p className="text-xs font-medium text-gray-500">Taluk Rank</p>
        </div>
      </div>
    </div>
  );
};

export default RankingDisplay;